// extracted by mini-css-extract-plugin
export var addButton = "_dq-0";
export var border = "_dq-8";
export var check = "_dq-h";
export var danger = "_dq-6";
export var dropdownContainer = "_dq-1";
export var editModalBody = "_dq-j";
export var footerContainer = "_dq-i";
export var fullWidth = "_dq-a";
export var hide = "_dq-9";
export var icon = "_dq-3";
export var input = "_dq-7";
export var inputFlex = "_dq-b";
export var inputWrapper = "_dq-c";
export var manualFocus = "_dq-5";
export var optionButton = "_dq-4";
export var pillWrapper = "_dq-e";
export var pointer = "_dq-2";
export var showOverflow = "_dq-f";
export var tagsFlex = "_dq-d";
export var xButton = "_dq-g";